import { useEffect, useState, memo } from 'react'
import { useToast } from '../context'

export default memo(function ToastContainer() {
  const { toasts } = useToast()

  return (
    <div className="fixed bottom-4 right-4 left-4 sm:left-auto z-[200] flex flex-col gap-2 pointer-events-none safe-bottom">
      {toasts.map(toast => (
        <Toast key={toast.id} toast={toast} />
      ))}
    </div>
  )
})

const Toast = memo(function Toast({ toast }) {
  const [show, setShow] = useState(false)
  const { removeToast } = useToast()

  useEffect(() => {
    requestAnimationFrame(() => setShow(true))
  }, [])

  const styles = {
    success: { color: 'var(--color-success)', icon: '✓' },
    error: { color: 'var(--color-error)', icon: '✕' },
    warning: { color: 'var(--color-warn)', icon: '!' },
    info: { color: 'var(--color-info)', icon: 'ℹ' }
  }

  const { color, icon } = styles[toast.type] || styles.info

  return (
    <div
      className={`
        flex items-center gap-3 px-4 py-3 rounded-lg border shadow-lg
        sm:min-w-[280px] sm:max-w-[360px] pointer-events-auto
        transform-gpu transition-all duration-200 ease-out
        ${show ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}
      `}
      style={{ 
        backgroundColor: 'var(--bg-elevated)',
        borderColor: 'var(--color-border)',
        boxShadow: 'var(--shadow-lg)'
      }}
    >
      <span 
        className="flex-shrink-0 w-5 h-5 rounded-full flex items-center justify-center text-xs font-bold"
        style={{ backgroundColor: `color-mix(in srgb, ${color} 20%, transparent)`, color }}
      >
        {icon}
      </span>
      <span className="flex-1 text-sm" style={{ color: 'var(--text-primary)' }}>
        {toast.message}
      </span>
      <button
        onClick={() => removeToast(toast.id)}
        className="flex-shrink-0 p-1 rounded opacity-50 hover:opacity-100 transition-opacity"
        style={{ color: 'var(--text-muted)' }}
      >
        <svg viewBox="0 0 24 24" fill="currentColor" className="w-4 h-4">
          <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
        </svg>
      </button>
    </div>
  )
})
